import { memo } from "react"
import { Colors } from "themes/palette"

interface Props {
  color?: (typeof Colors)[keyof typeof Colors]
}

const IconError = (props: Props) => {
  const { color = Colors.error } = props

  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z"
        fill={`${color}`}
      />
      <path
        d="M16.2356 15.2577C16.729 15.7522 16.729 16.489 16.2356 16.9835C16.0234 17.1958 15.7532 17.3124 15.4848 17.3124C15.2164 17.3124 14.9462 17.1958 14.734 16.9835L12 14.2562L9.26605 16.9835C9.05388 17.1958 8.78369 17.3124 8.51527 17.3124C8.24685 17.3124 7.97667 17.1958 7.76449 16.9835C7.27106 16.489 7.27106 15.7522 7.76449 15.2577L10.4984 12.5305L7.76449 9.80334C7.27106 9.30883 7.27106 8.57204 7.76449 8.07753C8.25792 7.58302 8.98912 7.58302 9.48154 8.07753L12 10.8047L14.734 8.07753C15.2274 7.58302 15.9586 7.58302 16.4511 8.07753C16.9435 8.57204 16.9435 9.30883 16.4511 9.80334L13.7171 12.5305L16.2356 15.2577Z"
        fill="white"
      />
    </svg>
  )
}

export default memo(IconError)
